import { Component } from '@angular/core';

@Component({
	selector: 'detail-error',
	templateUrl: './detail-error.component.html',
	styleUrls: ['./detail-error.component.scss']
})
export class DetailError
{

}
